import React from 'react';
import { ZfDivider, ZfLink, ZfStack, ZfTypography } from '@zafire/react';

export const Header: React.FC = () => {
  return (
    <ZfStack direction="row" spacing="small" style={{ paddingBottom: 'var(--gap-vertical-md)' }}>
      <ZfTypography variant="label-medium" color="emphasis" weight="bold">
        Contact Note(s)
      </ZfTypography>
      <ZfDivider style={{ flex: 1, paddingTop: 'var(--padding-top-sm)' }} />
      <ZfLink size="medium" variant="default" trailing-icon="open_in_new">
        Open CLM partner contact notes
      </ZfLink>
    </ZfStack>
  );
};

export default Header;
